(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-bundle-builder]').forEach((builder) => {
      const items = [...builder.querySelectorAll('[data-bundle-item]')];
      const modes = [...builder.querySelectorAll('[data-bundle-mode]')];
      const total = builder.querySelector('[data-bundle-total]');
      const count = builder.querySelector('[data-bundle-count]');
      const message = builder.querySelector('[data-bundle-message]');
      const addButton = builder.querySelector('[data-bundle-add]');
      const currency = builder.dataset.currency || 'USD';
      const formatMoney = (amount) => new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount / 100);
      const selected = () => items.filter((item) => item.checked && !item.disabled);
      const subscriptionSelected = () => modes.some((mode) => mode.checked && mode.value === 'subscription');
      const update = () => {
        const chosen = selected();
        total.textContent = formatMoney(chosen.reduce((sum, item) => sum + Number(item.dataset.price || 0), 0));
        count.textContent = chosen.length ? `${chosen.length} item${chosen.length === 1 ? '' : 's'} selected` : 'Choose your routine';
        addButton.disabled = chosen.length === 0;
        if (subscriptionSelected() && chosen.some((item) => !item.dataset.sellingPlan)) {
          message.textContent = 'Subscription is not available for every selected item. Adjust your selection or choose one-time purchase.';
          addButton.disabled = true;
        } else {
          message.textContent = builder.dataset.reassurance || 'Your bundle is added to cart together.';
        }
      };
      items.forEach((item) => item.addEventListener('change', update));
      modes.forEach((mode) => mode.addEventListener('change', update));
      addButton.addEventListener('click', async () => {
        const chosen = selected();
        const recurring = subscriptionSelected();
        if (!chosen.length || (recurring && chosen.some((item) => !item.dataset.sellingPlan))) return;
        addButton.disabled = true;
        addButton.textContent = 'Adding your bundle...';
        const cartItems = chosen.map((item) => {
          const cartItem = { id: Number(item.dataset.variantId), quantity: 1 };
          if (recurring) cartItem.selling_plan = Number(item.dataset.sellingPlan);
          return cartItem;
        });
        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: cartItems }) });
          if (!response.ok) throw new Error('Unable to add the bundle.');
          window.location.assign(window.Shopify.routes.root + 'cart');
        } catch (error) {
          message.textContent = 'We could not add this bundle just now. Please try again.';
          addButton.disabled = false;
          addButton.textContent = builder.dataset.buttonLabel || 'Add bundle to cart';
        }
      });
      update();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-cart-section]');
    if (!section || section.dataset.cartReady === 'true') return;
    section.dataset.cartReady = 'true';

    const updateLine = async (input, quantity) => {
      const lineKey = input.name.replace(/^updates\[(.*)\]$/, '$1');
      const nextQuantity = Math.max(0, Number.parseInt(quantity, 10) || 0);
      if (!lineKey) return;
      input.value = nextQuantity;
      input.disabled = true;
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: nextQuantity })
        });
        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      } catch (error) {
        input.disabled = false;
      }
    };

    section.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cart-quantity]');
      if (!button) return;
      event.preventDefault();
      const input = button.parentElement.querySelector('input[name^="updates["]');
      if (input) updateLine(input, Number(input.value) + Number(button.dataset.cartQuantity));
    });

    section.addEventListener('change', (event) => {
      const input = event.target.closest('input[name^="updates["]');
      if (input) updateLine(input, input.value);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
const initializeSmsPreview=(scope=document)=>scope.querySelectorAll('[data-sl-sms-preview]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 const dialog=root.querySelector('[data-sms-preview-dialog]');
 const email=document.getElementById('SanaLeafWelcome-'+root.dataset.section);
 let previousFocus,timer;
 const open=()=>{
  if(!root.isConnected||dialog.open)return;
  if(email?.open){email.close();return;}
  if(document.querySelector('dialog[open]'))return;
  previousFocus=document.activeElement;
  root.querySelector('[data-sms-preview-fields]').hidden=false;
  root.querySelector('[data-sms-preview-success]').hidden=true;
  window.slPopupScrollLock.lock(dialog);dialog.showModal();dialog.querySelector('[data-sms-preview-close]')?.focus({preventScroll:true});
 };
 dialog.addEventListener('click',event=>event.stopPropagation());
 root.querySelector('[data-sms-preview-open]').addEventListener('click',event=>{event.stopPropagation();open()});
 root.querySelectorAll('[data-sms-preview-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
 root.querySelector('[data-sms-preview-complete]').addEventListener('click',()=>{
  root.querySelector('[data-sms-preview-fields]').hidden=true;
  root.querySelector('[data-sms-preview-success]').hidden=false;
  root.querySelector('.sl-welcome-decline').focus({preventScroll:true});
 });
 dialog.addEventListener('close',()=>{window.slPopupScrollLock.unlock(dialog);if(previousFocus?.isConnected)previousFocus.focus({preventScroll:true});});
 email?.addEventListener('close',()=>{clearTimeout(timer);timer=setTimeout(open,150);});
 if(email?.dataset.editorPreview==='true'&&new URLSearchParams(location.search).get('customer_posted')==='true')timer=setTimeout(open,800);
 document.addEventListener('shopify:section:unload',event=>{if(event.detail.sectionId===root.dataset.section){clearTimeout(timer);if(dialog.open)dialog.close();}});
});
initializeSmsPreview();
document.addEventListener('shopify:section:load',event=>initializeSmsPreview(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-section-id]').forEach(function(header) {
    var openButton = header.querySelector('[data-search-open]');
    var dialog = document.querySelector('[data-search-dialog]');
    if (!openButton || !dialog || openButton.dataset.searchBound) return;
    openButton.dataset.searchBound = 'true';
    var closeButton = dialog.querySelector('[data-search-close]');
    var input = dialog.querySelector('input[type="search"]');
    openButton.addEventListener('click', function() { dialog.showModal(); window.setTimeout(function() { input.focus(); }, 50); });
    closeButton.addEventListener('click', function() { dialog.close(); openButton.focus(); });
    dialog.addEventListener('click', function(event) { if (event.target === dialog) dialog.close(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  const showProductMedia = (section, index) => {
    const slides = [...section.querySelectorAll('.sl-pdp__slide')];
    if (!slides.length) return;
    const nextIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === nextIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
    });
    section.querySelectorAll('.sl-pdp__thumb').forEach((thumb, thumbIndex) => {
      const active = thumbIndex === nextIndex;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
    const counter = section.querySelector('[data-media-current]');
    if (counter) counter.textContent = String(nextIndex + 1);
    section.dataset.activeMedia = String(nextIndex);
  };
  document.addEventListener('click', (event) => {
    const mediaButton = event.target.closest('[data-media-target]');
    if (mediaButton) {
      const section = mediaButton.closest('[data-product-section]');
      showProductMedia(section, Number(mediaButton.dataset.mediaIndex));
    }
    const mediaStep = event.target.closest('[data-media-step]');
    if (mediaStep) {
      const section = mediaStep.closest('[data-product-section]');
      showProductMedia(section, Number(section.dataset.activeMedia || 0) + Number(mediaStep.dataset.mediaStep));
    }
    const variantButton = event.target.closest('[data-variant-id]');
    if (variantButton) {
      const section = variantButton.closest('[data-product-section]');
      section.querySelector('[data-variant-input]').value = variantButton.dataset.variantId;
      section.querySelectorAll('[data-variant-id]').forEach((button) => { const active = button === variantButton; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', active); });
      section.querySelector('[data-product-price]').textContent = variantButton.dataset.variantPrice;
      section.querySelector('[data-mobile-price]').textContent = variantButton.dataset.variantPrice;
      const addButton = section.querySelector('[data-add-button]');
      addButton.disabled = variantButton.dataset.variantAvailable !== 'true';
      addButton.textContent = addButton.disabled ? section.dataset.soldOutLabel : `${section.dataset.addLabel} · ${variantButton.dataset.variantPrice}`;
    }
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) { const input = quantityButton.parentElement.querySelector('[data-quantity-input]'); input.value = Math.max(1, Number(input.value) + Number(quantityButton.dataset.quantityChange)); }
    const bundleButton = event.target.closest('[data-bundle-offer]');
    if (bundleButton) {
      const section = bundleButton.closest('[data-product-section]');
      const currentVariant = section.querySelector('[data-variant-input]').value;
      bundleButton.disabled = true;
      const originalText = bundleButton.textContent;
      bundleButton.textContent = 'Adding...';
      const addOnVariant = Number(bundleButton.dataset.bundleOffer);
      const addOnQuantity = Math.max(1, Number(bundleButton.dataset.bundleQuantity || 1));
      const items = [{ id: Number(currentVariant), quantity: 1 }];
      if (Number(currentVariant) === addOnVariant) items[0].quantity += addOnQuantity;
      else items.push({ id: addOnVariant, quantity: addOnQuantity });
      const root = window.Shopify?.routes?.root || '/';
      let status = section.querySelector('[data-bundle-status]');
      if (!status) { status = document.createElement('p'); status.dataset.bundleStatus = ''; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); bundleButton.closest('.sl-inline-bundles').append(status); }
      status.textContent = 'Adding your bundle…';
      const cartUrl = new URL(root + 'cart', window.location.origin);
      const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewTheme) cartUrl.searchParams.set('preview_theme_id', previewTheme);
      let added = false;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
        .then(async (response) => { const result = await response.json(); if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this bundle. Please try again.'); added = true; return result; })
        .then(async () => {
          const code = (bundleButton.dataset.bundleDiscountCode || '').trim();
          if (code) { const response = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:code})}); if (!response.ok) throw new Error('Your items were added, but the discount could not be applied.'); await response.json(); }
          status.textContent = 'Bundle added. Opening your cart…';
          window.location.assign(cartUrl.toString());
        })
        .catch((error) => {
          status.textContent = added ? 'Your items are already in the cart. We could not finish applying the offer. Open your cart to review before checkout.' : error.message;
          bundleButton.disabled = added;
          bundleButton.textContent = added ? 'Items added' : originalText;
          if (added) { const link = document.createElement('a'); link.href = cartUrl.toString(); link.textContent = ' View cart'; status.append(link); }
        });
    }
    const scrollButton = event.target.closest('[data-scroll-purchase]');
    if (scrollButton) scrollButton.closest('[data-product-section]').querySelector('.sl-pdp-form').scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    let startX = 0;
    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const section = gallery.closest('[data-product-section]');
      showProductMedia(section, Number(section.dataset.activeMedia || 0) + (event.key === 'ArrowRight' ? 1 : -1));
    });
    gallery.addEventListener('pointerdown', (event) => { startX = event.clientX; });
    gallery.addEventListener('pointerup', (event) => {
      const distance = event.clientX - startX;
      if (Math.abs(distance) < 45) return;
      const section = gallery.closest('[data-product-section]');
      showProductMedia(section, Number(section.dataset.activeMedia || 0) + (distance < 0 ? 1 : -1));
    });
  });
  document.querySelectorAll('[data-description-organizer]').forEach((organizer) => {
    const source = organizer.querySelector('[data-product-description-source]');
    const overview = organizer.querySelector('[data-overview-content]');
    const ingredients = organizer.querySelector('[data-ingredients-content]');
    const facts = organizer.querySelector('[data-facts-content]');
    if (!source || !overview || !ingredients || !facts) return;
    const ingredientsConfigured = ingredients.textContent.trim().length > 0 || ingredients.querySelector('img');
    const factsConfigured = facts.textContent.trim().length > 0 || facts.querySelector('img');
    let destination = overview;
    [...source.children].forEach((node) => {
      const label = node.textContent.trim().toLowerCase().replace(/[:\s]+$/g, '');
      const isLabel = /^h[1-6]$/i.test(node.tagName) || (node.tagName === 'P' && node.children.length === 1 && node.firstElementChild.tagName === 'STRONG');
      const isIngredientLabel = label === 'ingredients' || label === 'ingredient list' || label.startsWith('ingredients:') || label.startsWith('other ingredients');
      if (isIngredientLabel) {
        destination = ingredients;
        organizer.querySelector('[data-ingredients-detail]').hidden = false;
        if (isLabel && (label === 'ingredients' || label === 'ingredient list')) return;
      }
      if (isLabel && (label === 'supplement facts' || label === 'nutrition facts')) {
        destination = facts;
        organizer.querySelector('[data-facts-detail]').hidden = false;
        return;
      }
      if (destination === ingredients && ingredientsConfigured) return;
      if (destination === facts && factsConfigured) return;
      destination.append(node.cloneNode(true));
    });
    if (!overview.textContent.trim()) organizer.querySelector('[data-overview-detail]').hidden = true;
  });

  const initializeSanaLeafSubscriptions = (scope = document) => {
    scope.querySelectorAll('[data-sl-subscription]').forEach((widget) => {
      if (widget.dataset.ready) return;
      widget.dataset.ready = 'true';
      const section = widget.closest('[data-product-section]');
      const form = widget.closest('form');
      const data = JSON.parse(widget.querySelector('[data-sl-plan-data]').textContent);
      const radios = [...widget.querySelectorAll('input[type="radio"]')];
      const monthly = radios.find((radio) => radio.value === 'monthly');
      const once = radios.find((radio) => radio.value === 'once');
      const planInput = widget.querySelector('[data-sl-selling-plan]');
      const format = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:widget.dataset.currency || 'USD'}).format(cents / 100);
      const update = () => {
        const variant = data.variants.find((item) => String(item.id) === section.querySelector('[data-variant-input]').value);
        if (!variant) return;
        monthly.disabled = !variant.plan || !variant.available;
        if (monthly.disabled) once.checked = true;
        const subscribed = monthly.checked && !monthly.disabled;
        planInput.disabled = !subscribed;
        planInput.value = subscribed ? String(variant.plan) : '';
        widget.querySelector('[data-sl-once-price]').textContent = format(variant.price);
        widget.querySelector('[data-sl-monthly-price]').textContent = variant.plan ? format(variant.subscriptionPrice) : '—';
        const savings = variant.plan && variant.price > 0 ? Math.round((variant.price - variant.subscriptionPrice) / variant.price * 100) : 0;
        widget.querySelector('[data-sl-save]').textContent = savings > 0 ? data.save.replace('__PERCENT__', savings) : '';
        widget.querySelector('[data-sl-save]').hidden = savings <= 0;
        widget.querySelector('[data-sl-compare]').textContent = savings > 0 ? format(variant.price) : '';
        widget.querySelector('[data-sl-subscription-unavailable]').hidden = !!variant.plan;
        widget.querySelector('[data-sl-subscription-note]').hidden = !subscribed;
        radios.forEach((radio) => radio.closest('label').classList.toggle('is-selected', radio.checked));
        const price = subscribed ? variant.subscriptionPrice : variant.price;
        const quantity = Math.max(1, Number(form.querySelector('[data-quantity-input]').value) || 1);
        section.querySelector('[data-product-price]').textContent = format(price);
        section.querySelector('[data-mobile-price]').textContent = format(price);
        const button = section.querySelector('[data-add-button]');
        button.disabled = !variant.available;
        button.textContent = variant.available ? (subscribed ? widget.dataset.addSubscription : widget.dataset.addOnce) + ' · ' + format(price * quantity) : widget.dataset.soldOut;
        section.querySelectorAll('.sl-bulk-pricing,.sl-inline-bundles').forEach((offer) => offer.hidden = subscribed);
      };
      form.addEventListener('change', update);
      form.addEventListener('input', (event) => { if (event.target.matches('[data-quantity-input]')) update(); });
      section.addEventListener('click', (event) => { if (event.target.closest('[data-variant-id],[data-quantity-change]')) requestAnimationFrame(update); });
      update();
    });
  };
  initializeSanaLeafSubscriptions();
  document.addEventListener('shopify:section:load', (event) => initializeSanaLeafSubscriptions(event.target));


  } catch(e) { console.error(e); }
})();
})();
